import api from './api';

// Connection
export const getWAStatus = () => api.get('/wa/status');
export const getWAQR = () => api.get('/wa/qr');
export const connectWA = () => api.post('/wa/connect');
export const disconnectWA = () => api.post('/wa/disconnect');
export const forceSyncWA = () => api.post('/wa/force-sync');

// Chats & Messages
export const getWAChats = (limit = 50) => api.get('/wa/chats', { params: { limit } });
export const getChatMessages = (chatJid, limit = 100) => api.get(`/wa/chats/${encodeURIComponent(chatJid)}/messages`, { params: { limit } });
export const sendWAMessage = (chatJid, message) => api.post('/wa/send', { chat_jid: chatJid, message });
export const markChatRead = (chatJid) => api.post(`/wa/chats/${encodeURIComponent(chatJid)}/read`);

// AI
export const getAutopilotStatus = () => api.get('/wa/autopilot');
export const toggleAutopilot = (enabled) => api.post('/wa/autopilot', { enabled });
export const suggestReply = (chatJid, message) => api.post('/wa/suggest', { chat_jid: chatJid, message });
